<div class="multiStepDropdown">
  <pp-search-box
    [ppPlaceholder]="'search' | ppTranslate"
    [ppValue]="keyword"
    (ppAction)="setKeyword($event)"
    [ppFocusOnInit]="true"
    ppSize="wide"
    ppColor="#667085"
  />

  @if (stepLoading[1] || (ppIsLoading() && currentStep === 1)) {
    <pp-spinner data-testid="top-spinner" />
  }

  @if (step) {
    <section [id]="`step-${step.index}`" class="multiStepDropdown__list">
      @if (step.index > 1) {
        <button class="multiStepDropdown__backButton" (click)="back()">
          <pp-icon
            [ppSVG]="iconMap[EIconPath.ICON_LEFT_MENU_ARROW_BACK_14]"
            ppColor="inherit"
            ppClass="setSize14"
          />

          <span class="multiStepDropdown__backButton--text">
            {{ 'back' | ppTranslate }}
          </span>
        </button>
      }

      @if (stepLoading[currentStep] || ppIsLoading()) {
        @if (currentStep > 1) {
          <p class="multiStepDropdown__loading">
            <pp-spinner data-testid="inner-spinner" />
          </p>
        }
      } @else if (!step.group.length) {
        <p class="multiStepDropdown__noData">{{ 'no_data_available' | ppTranslate }}</p>
      } @else {
        @for (group of step.group; track group.id) {
          <div class="multiStepDropdown__list">
            <div
              class="multiStepDropdown__group"
              [class.multiStepDropdown__value--disabled]="isLastStep && currentStep !== 1"
              [class.multiStepDropdown__value--selected]="
                (ppSelectedId() === group.id || ppSelectedParentId() === group.id) &&
                currentStep === 1
              "
              (click)="toggleGroup(group)"
            >
              <p
                class="multiStepDropdown__item"
                [class.multiStepDropdown__value--bold]="group.hideChildrenValues"
              >
                {{ group.label }}
              </p>

              @if ((!group?.values?.length && !isLastStep) || group.hideChildrenValues) {
                <pp-icon
                  ppClass="setSize18"
                  [ppSVG]="iconMap[EIconPath.ICON_MISC_RIGHT_ARROW_14]"
                />
              }
            </div>

            @if (!group.hideChildrenValues) {
              @if (!collapsedGroup?.[group.id] && group?.values?.length) {
                <ul class="multiStepDropdown__collection">
                  @for (value of group.values; track value.id) {
                    <li
                      class="multiStepDropdown__value"
                      [class.multiStepDropdown__value--selected]="
                        ppSelectedId() === value.id || ppSelectedParentId() === value.id
                      "
                      (click)="nextStep(group.id, value.id)"
                    >
                      <p [class.multiStepDropdown__value--bold]="value?.hasChildrenStep">
                        {{ value.label }}
                      </p>

                      @if (value?.hasChildrenStep) {
                        <pp-icon
                          ppClass="setSize18"
                          [ppSVG]="iconMap[EIconPath.ICON_MISC_RIGHT_ARROW_14]"
                        />
                      }
                    </li>
                  }
                </ul>
              }
              @if (!group?.values?.length) {
                <span class="multiStepDropdown__value">{{
                  'no_available_options' | ppTranslate
                }}</span>
              }
            }
          </div>
        }
      }
    </section>
  }
</div>
